import { Client, ClientAdapter } from '@interfaces/FW/Client';

export const getClientsAdapter = (data: ClientAdapter[]): Client => {
	const apiData = data[0];

	return {
		managers: apiData.Менеджеры.map((item) => {
			return {
				group: item.Группа,
				email: item.Email,
				phone: item.НомерТелефона,
				manager: item.Менеджер,
			};
		}), //Менеджеры
		debtAmount: apiData.СуммаДолга,
		numberOfOverdueDaysOfDebtc: apiData.КоличествоПростроченныхДнейДолга,
		identifiers: apiData.Идентификаторы.map((item) => {
			return {
				invoiceOutputInvoice: item.СчетВыводитьВСчетФактуру,
				walletGUID: item.Счет,
				name: item.Наименование,
				id: item.ИД,
			};
		}),
		isMainCounterpartyOfGroup: apiData.ЭтоГоловнойКонтрагентГруппы,
		externalCardIssuer: apiData.ЗовнішнійЕмітентКарток,
		useNewMechanismOfAvailableGasStations: apiData.ИспользоватьНовыйМеханизмДоступныхАЗС,
		nameFull: apiData.НаименованиеПолное,
		nomenclatureOfCurrenciesMutualAccountsName:
			apiData.НоменклатураВалютыВзаиморасчетовНаименование,
		nomenclatureOfCurrenciesMutualAccounts: apiData.НоменклатураВалютыВзаиморасчетов,
		contractName: apiData.ДоговорНаименование,
		numberOfDaysUntilBlocking: apiData.КоличествоДнейДоБлокировки,
		mutualSettlementCurrency: apiData.ВалютаВзаиморасчетов,
		nomenclatureOfCurrenciesMutualAccountsUnitOfMeasurement:
			apiData.НоменклатураВалютыВзаиморасчетовЕдиницаИзмерения,
		counterpartyIsSubjectToMilitaryLimits: apiData.ПоКонтрагентуДіютьВоєнніЛіміти,
		connectingContractors: apiData.ПодключениеПодрядчиков,
		cardTokenizationPermissionName: apiData.РазрешениеТокенизацииКартНаименование,
		mutualSettlementCurrencyLink: apiData.ВалютаВзаиморасчетовСсылка,
		allowCardTokenizationLink: apiData.РазрешениеТокенизацииКартСсылка,
		additionalInformation: apiData.ДополнительнаяИнформация,
		amountOfOverdueDebt: apiData.СуммаПростроченогоДолга,
		sendingMessagesAllowed: apiData.РазрешенаОтправкаСообщений,
		cooperationSchemeName: apiData.СхемаСотрудничестваНаименование,
		overdraftStatus: apiData.СтатусОвердрафта,
		topstitching: apiData.Отстрочка,
		monthlyLimitShift: apiData.СдвигМесячногоЛимита,
		headCounterpartyOfTheGroup:
			Object.keys(apiData.ГоловнойКонтрагентГруппы).length === 0
				? {}
				: {
						id: apiData.ГоловнойКонтрагентГруппы.ИД,
						name: apiData.ГоловнойКонтрагентГруппы.Наименование,
						codeEgrpou: apiData.ГоловнойКонтрагентГруппы.КодПоЕДРПОУ,
						TIN: apiData.ГоловнойКонтрагентГруппы.ИНН,
						certificateNumber: apiData.ГоловнойКонтрагентГруппы.НомерСвидетельства,
					},
		contract: apiData.Договор,
		activeGasStationAccess: apiData.АктивніДоступиАЗС,
		numberOfCreatedVirtualCards: apiData.КоличествоСозданныхВиртуальныхКарт,
		maximumNumberOfVirtualCards: apiData.МаксимальноеКоличествоВиртуальныхКарт,
		literWalletsAfterpayment: apiData.ЛитровыеКошелькиПослеоплата,
		generalOverdraft: apiData.ОбщийОвердрафт,
		TIN: apiData.ИНН,
		numberOfDaysOfDebt: apiData.КоличествоДнейДолга,
		codeEgrpou: apiData.КодПоЕДРПОУ,
		customerPhotoControlService: apiData.СервисКонтроляФотографийКлиентов,
		certificateNumber: apiData.НомерСвидетельства,
		blocked: apiData.Заблокирован,
		counterpartyName: apiData.КонтрагентНаименование,
		cooperationScheme: apiData.СхемаСотрудничества,
		counterparty: apiData.Контрагент,
		settlementCurrencyAbbreviation: apiData.ВалютаВзаиморасчетовСокращение,
		hideAdditionalCheckInfo: apiData.ЗапретВыводаДопИнформацииВЧек,
		allowEDO: apiData.ОбменПоЭДО,
		dontPrintPaperReceipt: apiData.НеПечататьБумажныйЧек,
		superDiscountStatus: apiData.СтатусСуперСкидкиТК,
		controlCarRegistrationNumber: apiData.КонтролироватьНомерАвтотранспорта,
	};
};

export const getAllClientsAdapter = (data: ClientAdapter[]): Client[] => {
	return data.map((apiData) => ({
		managers: apiData.Менеджеры.map((item) => {
			return {
				group: item.Группа,
				email: item.Email,
				phone: item.НомерТелефона,
				manager: item.Менеджер,
			};
		}), //Менеджеры
		debtAmount: apiData.СуммаДолга,
		numberOfOverdueDaysOfDebtc: apiData.КоличествоПростроченныхДнейДолга,
		identifiers: apiData.Идентификаторы.map((item) => {
			return {
				invoiceOutputInvoice: item.СчетВыводитьВСчетФактуру,
				walletGUID: item.Счет,
				name: item.Наименование,
				id: item.ИД,
			};
		}),
		isMainCounterpartyOfGroup: apiData.ЭтоГоловнойКонтрагентГруппы,
		externalCardIssuer: apiData.ЗовнішнійЕмітентКарток,
		useNewMechanismOfAvailableGasStations: apiData.ИспользоватьНовыйМеханизмДоступныхАЗС,
		nameFull: apiData.НаименованиеПолное,
		nomenclatureOfCurrenciesMutualAccountsName:
			apiData.НоменклатураВалютыВзаиморасчетовНаименование,
		nomenclatureOfCurrenciesMutualAccounts: apiData.НоменклатураВалютыВзаиморасчетов,
		contractName: apiData.ДоговорНаименование,
		numberOfDaysUntilBlocking: apiData.КоличествоДнейДоБлокировки,
		mutualSettlementCurrency: apiData.ВалютаВзаиморасчетов,
		nomenclatureOfCurrenciesMutualAccountsUnitOfMeasurement:
			apiData.НоменклатураВалютыВзаиморасчетовЕдиницаИзмерения,
		counterpartyIsSubjectToMilitaryLimits: apiData.ПоКонтрагентуДіютьВоєнніЛіміти,
		connectingContractors: apiData.ПодключениеПодрядчиков,
		cardTokenizationPermissionName: apiData.РазрешениеТокенизацииКартНаименование,
		mutualSettlementCurrencyLink: apiData.ВалютаВзаиморасчетовСсылка,
		allowCardTokenizationLink: apiData.РазрешениеТокенизацииКартСсылка,
		additionalInformation: apiData.ДополнительнаяИнформация,
		amountOfOverdueDebt: apiData.СуммаПростроченогоДолга,
		sendingMessagesAllowed: apiData.РазрешенаОтправкаСообщений,
		cooperationSchemeName: apiData.СхемаСотрудничестваНаименование,
		overdraftStatus: apiData.СтатусОвердрафта,
		topstitching: apiData.Отстрочка,
		monthlyLimitShift: apiData.СдвигМесячногоЛимита,
		headCounterpartyOfTheGroup:
			Object.keys(apiData.ГоловнойКонтрагентГруппы).length === 0
				? {}
				: {
						id: apiData.ГоловнойКонтрагентГруппы.ИД,
						name: apiData.ГоловнойКонтрагентГруппы.Наименование,
						codeEgrpou: apiData.ГоловнойКонтрагентГруппы.КодПоЕДРПОУ,
						TIN: apiData.ГоловнойКонтрагентГруппы.ИНН,
						certificateNumber: apiData.ГоловнойКонтрагентГруппы.НомерСвидетельства,
					},
		contract: apiData.Договор,
		activeGasStationAccess: apiData.АктивніДоступиАЗС,
		numberOfCreatedVirtualCards: apiData.КоличествоСозданныхВиртуальныхКарт,
		maximumNumberOfVirtualCards: apiData.МаксимальноеКоличествоВиртуальныхКарт,
		literWalletsAfterpayment: apiData.ЛитровыеКошелькиПослеоплата,
		generalOverdraft: apiData.ОбщийОвердрафт,
		TIN: apiData.ИНН,
		numberOfDaysOfDebt: apiData.КоличествоДнейДолга,
		codeEgrpou: apiData.КодПоЕДРПОУ,
		customerPhotoControlService: apiData.СервисКонтроляФотографийКлиентов,
		certificateNumber: apiData.НомерСвидетельства,
		blocked: apiData.Заблокирован,
		counterpartyName: apiData.КонтрагентНаименование,
		cooperationScheme: apiData.СхемаСотрудничества,
		counterparty: apiData.Контрагент,
		settlementCurrencyAbbreviation: apiData.ВалютаВзаиморасчетовСокращение,
		hideAdditionalCheckInfo: apiData.ЗапретВыводаДопИнформацииВЧек,
		allowEDO: apiData.ОбменПоЭДО,
		dontPrintPaperReceipt: apiData.НеПечататьБумажныйЧек,
		superDiscountStatus: apiData.СтатусСуперСкидкиТК,
		controlCarRegistrationNumber: apiData.КонтролироватьНомерАвтотранспорта,
	}));
};
